import { render, staticRenderFns } from "./sales_distribution.vue?vue&type=template&id=35f41a35"
import script from "./sales_distribution.vue?vue&type=script&lang=js"
export * from "./sales_distribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35f41a35')) {
      api.createRecord('35f41a35', component.options)
    } else {
      api.reload('35f41a35', component.options)
    }
    module.hot.accept("./sales_distribution.vue?vue&type=template&id=35f41a35", function () {
      api.rerender('35f41a35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/site_settings/sales_distribution.vue"
export default component.exports